export default {
  rankOrder: {
    ariaAddOption: 'Tambah {label} ke senarai kedudukan',
    ariaMoveUp: 'Naikkan {label}',
    ariaMoveDown: 'Turunkan {label}',
    ariaRemoveOption: 'Alih keluar {label} daripada senarai kedudukan',
  },
  coe: {
    ariaDisclaimer: 'Notis',
    ariaQuestion: 'Soalan',
    ariaConversationHistory: 'Sejarah perbualan',
    ariaYourResponse: 'Jawapan anda {number}',
    ariaFollowUpQuestion: 'Soalan susulan {number}',
    ariaResponseInput: 'Medan jawapan',
    ariaRespondingTo: 'Membalas',
    ariaSendResponse: 'Hantar jawapan',
    ariaThinking: 'Berfikir'
  },
  deviceView: {
    toolbar: 'Peranti pratonton',
    mobile: 'Mudah alih',
    tablet: 'Tablet',
    desktop: 'Desktop'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'Logo QuestDIY'
  }
}
